import { downloadFile } from "@/shared/utils"
import { toast } from "sonner"

export const useDownloadContentItem = (
  audioUrl: string,
  filename: string = "downloaded-file"
) => {
  const downloadItem = async () => {
    toast.promise(downloadFile(audioUrl, filename), {
      loading: `Downloading ${filename}...`,
      success: `Downloaded ${filename} successfully`,
      error: "Failed to download",
    })
  }

  return { downloadItem }
}
